export type Environment = "debug" | "development" | "staging" | "production";

type AppConfig = {
  apiUrl: string;
  imagesUrl: string;
  sentryEnabled: boolean;
  sentryPublicDsn: string;
  sentryEnv: Environment;
};

const defaultConfig: AppConfig = {
  // we hit production on all configs by default as this is read-only and we use real data
  apiUrl: "https://cuanto.app",
  imagesUrl: "https://images.cuanto.app",
  sentryEnabled: false,
  sentryPublicDsn:
    "https://685a60bc6e37fd425386e14414bc152e@o121062.ingest.us.sentry.io/4506983594590208",
  sentryEnv: "development",
};

const configsByAppEnv: Record<Environment, Partial<AppConfig>> = {
  debug: {
    apiUrl: "http://localhost:3000",
  },
  development: {},
  staging: {
    sentryEnabled: true,
    sentryEnv: "staging",
  },
  production: {
    sentryEnabled: true,
    sentryEnv: "production",
  },
};

const APP_ENV = (process.env.EXPO_PUBLIC_APP_ENV ||
  "development") as Environment;
const RELEASE_NAME = process.env.EXPO_PUBLIC_RELEASE_NAME || "local";

export const Config = Object.assign(defaultConfig, configsByAppEnv[APP_ENV], {
  releaseName: RELEASE_NAME,
  appEnv: APP_ENV,
});
